import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import { setAllFbbPlans, setBoosterFbbPlans, planList, BoosterplanList } from './actions';
import immerHandleActions from 'redux/utils/immerHandleActions';
import { commitmentTimesFBB, commitmentTimesFiberPro } from 'components/ServicesTables/FBBTable/constants';

const init: types.redux.fbbPlans.State = {
	plans: {
		fbb: {
			12: {
				planList: [],
			},
			24: {
				planList: [],
			},
			36: {
				planList: [],
			},
		},
		fbbPro: {
			12: {
				planList: [],
			},
			24: {
				planList: [],
			},
			36: {
				planList: [],
			},
		},
		booster: {
			12: {
				planList: [],
			},
			24: {
				planList: [],
			},
			36: {
				planList: [],
			},
		},
	},
};
const reducers = {
	[setAllFbbPlans]: (state: types.redux.fbbPlans.State, { payload }: planList) => {
		commitmentTimesFBB.map((time: number) => {
			state.plans.fbb[time].planList = payload.availableCatalogEntryViews
				.filter((singleEntry) => {
					return (
						parseInt(extractAttributeValue(singleEntry, CustomAttribute.CONTRACT_DURATION)) === time &&
						(extractAttributeValue(singleEntry, CustomAttribute.FBB_PRO) === undefined ||
							extractAttributeValue(singleEntry, CustomAttribute.FBB_PRO) === 'FALSE')
					);
				})
				.sort(comparePlans);
		});
		commitmentTimesFiberPro.map((time: number) => {
			state.plans.fbbPro[time].planList = payload.availableCatalogEntryViews
				.filter((singleEntry) => {
					return (
						parseInt(extractAttributeValue(singleEntry, CustomAttribute.CONTRACT_DURATION)) === time &&
						extractAttributeValue(singleEntry, CustomAttribute.FBB_PRO) === 'TRUE'
					);
				})
				.sort(comparePlans);
		});
		return state;
	},
	[setBoosterFbbPlans]: (state: types.redux.fbbPlans.State, { payload }: BoosterplanList) => {
		commitmentTimesFiberPro.map((time: number) => {
			state.plans.booster[time].planList = payload.plans.filter((singleEntry) => {
				return parseInt(singleEntry.contractInMonths) === time;
			});
		});
	},
};
const comparePlans = (firstPlan: types.ecommerce.CatalogEntryView, secondPlan: types.ecommerce.CatalogEntryView) => {
	const firstIndex = parseFloat(extractAttributeValue(firstPlan, CustomAttribute.HIERARCHY_INDEX));
	const secondIndex = parseFloat(extractAttributeValue(secondPlan, CustomAttribute.HIERARCHY_INDEX));
	return firstIndex - secondIndex;
};
export default immerHandleActions(reducers, init);
